export default __webpack_public_path__ + "static/media/start-bg.a33d8406.png";